import { render } from "./Indx.vue?vue&type=template&id=d8d841d0&scoped=true"
import script from "./Indx.vue?vue&type=script&lang=js"
export * from "./Indx.vue?vue&type=script&lang=js"

import "./Indx.vue?vue&type=style&index=0&id=d8d841d0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d841d0"]])

export default __exports__